import React from "react";
import { Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import { auth } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Header.css";
function Header() {
  const [user] = useAuthState(auth);

  const signOut = () => {
    auth.signOut();
    // <Redirect to="/" />
  };
  return (
    <div className="header">
      <Link
        to="/"
        className="home_link"
        style={{ cursor: "default", textDecoration: "none" }}
      >
        <h4 className="ml-1">MessX</h4>
      </Link>
      <Col xs={6} md={4} className="profile">
        <Image className="image-avatar" src={user.photoURL} roundedCircle />
        <h4
          className="user_name"
          style={{ cursor: "default", textDecoration: "none" }}
          onClick={signOut}
        >
          {user.displayName}
        </h4>
      </Col>
    </div>
  );
}

export default Header;
